<template>
  <div class="app">
    <div class="dictionary">
      <h1>📖 Oriental Dictionary App</h1>

      <input
        v-model="word"
        @keyup.enter="searchWord"
        placeholder="Enter a word"
      />

      <button @click="searchWord">Search</button>

      <p v-if="loading" class="info">Searching...</p>
      <p v-if="error" class="error">{{ error }}</p>

      <div v-if="result" class="result">
        <h2>{{ result.word }}</h2>
        <p class="phonetic">{{ result.phonetic }}</p>

        <div
          v-for="(meaning, index) in result.meanings"
          :key="index"
          class="meaning"
        >
          <h4>{{ meaning.partOfSpeech }}</h4>
          <p>{{ meaning.definitions[0].definition }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const word = ref("");
const result = ref(null);
const loading = ref(false);
const error = ref("");

const searchWord = async () => {
  if (!word.value.trim()) {
    error.value = "Please enter a word";
    return;
  }

  loading.value = true;
  error.value = "";
  result.value = null;

  try {
    const res = await fetch(
      `https://api.dictionaryapi.dev/api/v2/entries/en/${word.value}`
    );

    if (!res.ok) throw new Error("Word not found");

    const data = await res.json();
    result.value = data[0];
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.app {
  min-height: 100vh;
  background: linear-gradient(120deg, #4facfe, #00f2fe);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;
}

.dictionary {
  background: #fff;
  padding: 30px;
  width: 100%;
  max-width: 420px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

input {
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

button {
  width: 100%;
  padding: 12px;
  background: #4facfe;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #00c6ff;
}

.result {
  margin-top: 20px;
  text-align: left;
}

.phonetic {
  color: #666;
  font-style: italic;
}

.meaning {
  margin-top: 10px;
}

.info {
  color: #555;
}

.error {
  color: red;
  margin-top: 10px;
}
</style>
